import { FieldDefinition } from "./fieldDefinitions";

export interface SurgeryTypeDto {
  surgeryTypeId: number;
  surgeryTypeCode: string;
  surgeryTypeDescr: string;
  category?: string;
  estimatedDurationMinutes?: number;
  active: boolean;
  userIdInserted: number;
  dateInserted: string;
}

export const surgeryTypeKeyId = "surgeryTypeId" as const;

export const surgeryTypeFields: FieldDefinition[] = [
  {
    name: "surgeryTypeCode",
    label: "Κωδικός Χειρουργείου",
    type: "text",
    required: true,
  },
  {
    name: "surgeryTypeDescr",
    label: "Περιγραφή",
    type: "text",
    required: true,
  },
  {
    name: "category",
    label: "Κατηγορία",
    type: "text",
    required: false,
  },
  {
    name: "estimatedDurationMinutes",
    label: "Εκτιμώμενη Διάρκεια (Λεπτά)",
    type: "number",
    required: false,
  },
  {
    name: "active",
    label: "Ενεργό",
    type: "boolean",
    required: true,
  },
] as const;

export const surgeryTypeFilters = surgeryTypeFields.filter((f) =>
  ["surgeryTypeCode", "surgeryTypeDescr", "category"].includes(f.name),
);

export const surgeryTypeFormData: string[] = [
  "surgeryTypeCode",
  "surgeryTypeDescr",
  "category",
  "estimatedDurationMinutes",
];
